import { useState, useEffect, useContext, useRef } from 'react';

import { getMobileOperatorList, getMobileZoneList, getPlanDetails, mobileRechargeRequest } from '../../utils/api';
import { clickOutside, isEmpty, overLayers } from '../../utils/common';
import SelectOprater from '../../Components/SelectOprater';
import IconClose from '../../assets/images/IconClose';
import OfferBanner from '../../Components/OfferBanner';
import { TabContentWrapper, PlanWrapper, YellowStripWrapper, AlertWrapper, TableWrapper } from '../UI/styledConstants';
import Loader from '../UI/Loader/Loader';
import CustomDropdown from '../CustomDropdown/CustomDropdown';
import { useLocation } from 'react-router-dom';
import RechargeReceipt from './RechargeReceipt';
import EnterMpin from '../Mpin/EnterMpin';
import bbpsLogo from '../../assets/images/BbpsLogo.png';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import Input from '../UIbox/Input';

const initialControls = {
	operatorCode: '',
	phoneNumber: '',
	rechargeAmount: '',
	type: 'MOBILE',
	zone: '',
};

export default function Component({ className = '' }) {
	const [planDetails, setPlanDetails] = useState(null);
	const [activeMobilePop, setActiveMobilePop] = useState(false);
	const [activePlan, setActivePlan] = useState('talktime');
	const [message, setMessage] = useState({});
	const [rechargeType, setRechargeType] = useState('PREPAID');
	const [provider, setProvider] = useState('');
	const [rechargDataResp, setRechargDataResp] = useState({});
	const [formDetails, setFormDetails] = useState({
		operatorCode: '',
		phoneNumber: '',
		rechargeAmount: '',
		type: 'PREPAID_RECHARGE',
		zone: '',
	});

	const [operatorList, setOperatorList] = useState([]);
	const [zoneList, setZoneList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [mpinPop, setMpinPop] = useState(true);
	const numberReg = /^[0-9]+$/;
	// const nameReg = /^[A-Za-z\s]+$/i;
	const location = useLocation();

	const { setRefresh, refresh, geolocation, setAlert } = useContext(GlobleContaxt);

	const rechargeFormHandler = (event) => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			setAlert({ type: 'error', msg: 'Please login first to continue' });
			return;
		}
		if (event.target.name === 'rechargeAmount' || event.target.name === 'phoneNumber') {
			if (!numberReg.test(event.target.value) && event.target.value) {
				return false;
			}
		}

		setFormDetails({
			...formDetails,
			[event.target.name]: event.target.value,
		});
	};

	const handleFormPlan = (data) => {
		setActiveMobilePop(false);
		setFormDetails({
			...formDetails,
			rechargeAmount: data,
		});
	};

	const handleOptionChange = (changeEvent) => {
		setRechargeType(changeEvent.target.value);
	};

	useEffect(() => {
		if (!isEmpty(localStorage.getItem('ID Token'))) {
			setLoading(true);
			getMobileOperatorList().then((data) => {
				setLoading(false);
				if (data?.success) {
					setOperatorList(data?.data);
				}
			});

			getMobileZoneList().then((data) => {
				if (data?.success) {
					setZoneList(data?.data);
				}
			});
		}
	}, [localStorage.getItem('ID Token')]);

	useEffect(() => {
		const prov = provider.split(',');

		setFormDetails({
			...formDetails,
			operatorCode: prov[0],
		});
	}, [provider]);

	const planHandler = async () => {
		const prov = provider.split(',');
		if (formDetails.operatorCode === '') {
			setMessage({ type: 'error', msg: 'Please select operator', place: 'local' });
			return;
		} else if (formDetails.zone === '') {
			setMessage({ type: 'error', msg: 'Please select circle', place: 'local' });
			return;
		}
		setLoading(true);
		const params = { zone: formDetails.zone, operator: prov[1] };
		const planData = await getPlanDetails(params);
		setLoading(false);
		setPlanDetails(planData?.data || null);
		if (!isEmpty(planData?.data)) {
			setActiveMobilePop(true);
		}
	};

	const rechargeHandler = () => {
		if (formDetails.phoneNumber === '' || formDetails.phoneNumber.length != 10) {
			setMessage({ type: 'error', msg: 'Please enter correct Mobile Number', place: 'local' });
			return;
		} else if (formDetails.operatorCode === '') {
			setMessage({ type: 'error', msg: 'Please select operator', place: 'local' });
			return;
		} else if (formDetails.zone === '') {
			setMessage({ type: 'error', msg: 'Please select circle', place: 'local' });
			return;
		} else if (formDetails.rechargeAmount === '') {
			setMessage({ type: 'error', msg: 'Please input amount', place: 'local' });
			return;
		}
		setLoading(true);

		const param = {
			operatorCode: formDetails.operatorCode,
			phoneNumber: formDetails.phoneNumber,
			rechargeAmount: formDetails.rechargeAmount,
			type: formDetails.type,
		};
		mobileRechargeRequest(param).then((data) => {
			setLoading(false);

			if (data?.success) {
				setRechargDataResp(data?.data);
				setRefresh(!refresh);
			} else {
				if (data?.errorCodeList?.length > 0) {
					setAlert({ type: 'error', msg: data?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: data?.msg });
				}
			}
		});
	};

	useEffect(() => {
		if (!isEmpty(message)) {
			setTimeout(() => {
				setMessage({});
			}, 5000);
		}
	}, [message]);

	const queryParams = new URLSearchParams(location.search);
	const paramValue = queryParams.get('type');
	useEffect(() => {
		if (!isEmpty(paramValue)) {
			if (paramValue === 'mobile') {
				setFormDetails({
					operatorCode: '',
					phoneNumber: '',
					rechargeAmount: '',
					type: 'MOBILE',
					zone: '',
				});
			}
		}
	}, [paramValue]);

	function closePop() {
		setFormDetails({ ...setFormDetails });
		setRechargDataResp({});

		setMessage({});
	}

	const closeMpin = () => {
		setMpinPop(false);
	};

	const popupRef = useRef(null)
		useEffect(() =>{
			overLayers(activeMobilePop,"sm")
			clickOutside(activeMobilePop,popupRef,()=>{setActiveMobilePop(false)})
			return(()=>{
				overLayers(false,"sm")
			clickOutside(false,popupRef,()=>{setActiveMobilePop(false)})
			})
		},[activeMobilePop])
	return (
		<>
			<TabContentWrapper className={`tab-content-wrapper ${className}`}>
				{!isEmpty(message) && message.place === 'globle' && (
					<AlertWrapper className={`${message.type} globle`}>
						<span className="close" onClick={() => setMessage({})}>
							×
						</span>
						{message.msg}
					</AlertWrapper>
				)}
				<div className="tab-content-left">
					<div className="flex headingText">
						<h2 className="">Mobile Recharge</h2>
						{/* <img  src={bbpsLogo}  alt='bbps logo' style={{width:"34px"}}/> */}
					</div>
					<div className="form-field">
						<div className="radio-group" onChange={rechargeFormHandler}>
							<label className="radio" style={{ marginRight: '40px' }}>
								<input type="radio" name="rechargeType" value="PREPAID" checked={rechargeType === 'PREPAID'} onChange={handleOptionChange} /> Prepaid
							</label>
							<label className="radio">
								<input type="radio" name="rechargeType" value="POSTPAID" checked={rechargeType === 'POSTPAID'} onChange={handleOptionChange} /> Postpaid
							</label>
						</div>
					</div>
					<Input label={'Phone Number'} name={'phoneNumber'} onChange={(e) => rechargeFormHandler(e)} value={formDetails.phoneNumber} maxLength={10} inputMode="numeric" error={''} />

					<div className="form-field">
						<CustomDropdown list={operatorList} setProvider={setProvider} type="mobile" setMessage={setMessage} accessLoaction={false} />
					</div>
					<Input
						type={"select"}
						label={"Select Circle"}
						name={"zone"}
						onChange={(e) => rechargeFormHandler(e)}
						value={formDetails.zone}
						potions={zoneList}
						keys={{value:"zoneCode",label:"zoneName"}}
						error={""}
					/>
					<Input label={'Amount'} name={'rechargeAmount'} onChange={(e) => rechargeFormHandler(e)} value={formDetails.rechargeAmount} maxLength={10} inputMode="numeric" error={''}>
						<button onClick={planHandler} className="inputButton">
							Browse Plans
						</button>
					</Input>

					{!isEmpty(message) && message.place === 'local' && (
						<AlertWrapper className={message.type}>
							<span className="close" onClick={() => setMessage({})}>
								×
							</span>
							{message.msg}
						</AlertWrapper>
					)}

					<button type="submit" className="button-outline" onClick={rechargeHandler}>
						PROCEED TO RECHARGE
					</button>
				</div>
				<div className={`tab-content-right tab-content-right-mobile ${!activeMobilePop ? '' : 'active'}`} ref={popupRef}>
					<div
						className="d-m-block close-pop"
						onClick={() => {
							setActiveMobilePop(false);
						}}
					>
						<IconClose />
					</div>
					{!isEmpty(planDetails) ? (
						<PlanWrapper>
							<div className="plan-tabs-wrapper ">
								{Object.keys(planDetails).map((key, i) => (
									<div key={i} className={`${activePlan === key ? 'active' : ''} plan-tab`} onClick={() => setActivePlan(key)}>
										{key}
									</div>
								))}
							</div>

							<TableWrapper className="mobile-plan-table table-card-wrapper">
								<table className="table">
									<thead className="table-head">
										<tr>
											<th>Sr No</th>
											<th>Amount</th>
											<th>Benefit</th>
											<th>Validity</th>
											<th className="text-right">Action</th>
										</tr>
									</thead>
									<tbody className="table-body">
										{!isEmpty(activePlan) &&
											planDetails[activePlan].map((data, i) => {
												return (
													<tr key={i}>
														<td className="d-m-none">
															<span className="card-th">Sr No</span>
															<span>{i + 1}</span>
														</td>
														<td>
															<span className="card-th">Amount</span>
															<span>&#8377; {data.rs}</span>
														</td>
														<td>
															<span className="card-th">Benefit</span>
															<span>
																&#8377; {data.rechargeTalktime || 0} {data.rechargeType}
															</span>
														</td>
														<td>
															<span className="card-th">Validity</span>
															<span>{data.validity}</span>
														</td>
														<td>
															<span className="card-th">Action</span>
															<div className="select-link flex justify-end">
																<div onClick={() => handleFormPlan(data.rs)}>&#8377; {data.rs}</div>
															</div>
														</td>
													</tr>
												);
											})}
									</tbody>
								</table>
							</TableWrapper>
						</PlanWrapper>
					) : (
						<>{!loading && <OfferBanner />}</>
					)}
				</div>
				{loading && <Loader />}
				{!isEmpty(rechargDataResp) && !loading && <RechargeReceipt closePop={closePop} rechargDataResp={rechargDataResp} />}
			</TabContentWrapper>
			{/* <YellowStripWrapper className="yellow-strip">
				<strong>No Wallet KYC Required </strong> 😊to pay using UPI on Pay2Mobile. <strong></strong>
			</YellowStripWrapper> */}

			<SelectOprater />
			{/* {mpinPop && <EnterMpin
			close ={closeMpin}

			 />} */}
		</>
	);
}
